import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import EnvironmentUtils from "utils/EnviromentUtils";

/**
 * ★本番として数える host（完全一致）★
 *
 * ⚠️ 2026-08-26 実測 …これまでは `process.env.NODE_ENV === "production"` だけで
 *   分けていた。ところが QA も `yarn build`（react-scripts build）で作るので
 *   ★NODE_ENV は QA ビルドでも production★ になる。
 *   ⇒ QA の試し（私や代表の動作確認）が 本番の数に 混ざっていた。
 *   ⇒ ⇒ オンボーディングの完走率を数える時、試験が 完走として 数えられる。
 *
 * ⚠️ 照合は ★完全一致★ でなければならない。
 *   new.qa.staff.no-tel.com は staff.no-tel.com を ★部分文字列として含む★。
 *   endsWith / includes で見ると QA が 本番として 数えられる。
 *   試し …node scripts/check-ga-host-gate.js
 *
 * 新しい本番の host が増えたら ここに足す（足さないと 黙って数えなくなる）。
 * ⇒ 混ぜるより 数え落とす方を 選ぶ。混ざった数は 後から 分けられない。
 */
export const PRODUCTION_HOSTS = ["staff.no-tel.com", "new.staff.no-tel.com"];

export function isProductionHost(hostname: string): boolean {
  return PRODUCTION_HOSTS.indexOf(hostname) >= 0;
}

/**
 * ★送り先の項目★
 *
 * ⚠️ EnvironmentUtils.getGaTrackingCode() は 前から在ったが
 *   ★呼んでいる所が 0 件★ で、ここが 直書きしていた（2026-08-26 実測）。
 *   env を 見る形へ直す。ただし env は 現在 3 つとも 空なので、
 *   ★空なら これまでの値を 使う★（繋いだ途端に 計測が 止まらないように）。
 */
const FALLBACK_MEASUREMENT_ID = "G-12TYHW4V9B";

export function measurementId(): string {
  return EnvironmentUtils.getGaTrackingCode() || FALLBACK_MEASUREMENT_ID;
}

// initialize は 1 度だけ。これまでは location が変わる度に 呼んでいた。
let initialized = false;

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isProductionHost(window.location.hostname)) return;

    if (!initialized) {
      ReactGA.initialize(measurementId());
      initialized = true;
    }
    ReactGA.send({
      hitType: "pageview",
      // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
      page: location.pathname + location.search,
    });
  }, [location]);
};

export default usePageTracking;
